import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';
import { FbDropdownWidget, WidgetBase } from '../../../models';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenToDivPipe } from '../../../helpers/token-to-div.pipe';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';
@Component({
  selector: 'fb-dropdown',
  templateUrl: './fb-dropdown.component.html',
  styleUrls: ['./fb-dropdown.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    TokenToDivPipe,
    NgSelectModule,
    ScribeSuggestionIndicatorComponent,
    AmendmentFieldIndicatorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbDropdownComponent extends WidgetBase implements OnInit {
  @Input()
  public override set payload(value) {
    this._payload = value;

    if (this._payload?.properties?.columns?.length) {
      this.sanitizeOptions();
    }

    this._initItems();
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  public override _wrap = false;
  @Input()
  public override set wrap(value: boolean) {
    this._wrap = value;
  }
  public override get wrap() {
    return this._wrap;
  }

  public override _wrapContent = false;
  @Input()
  public override set wrapContent(value: boolean) {
    this._wrapContent = value;
  }
  public override get wrapContent() {
    return this._wrapContent;
  }

  public items: any = [];

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  override isValid() {
    return new FbDropdownWidget(this.payload).isValid();
  }

  private _initItems() {
    this.items = [];

    this._payload.properties.columns.forEach((it, i) => {
      let list: any = [];
      if (it.items.value) {
        list = it.items.value.map((item) => ({
          text: item.properties.text.value,
          value: item.properties.value.value,
        }));
      }
      // To resolve iOS v. <=13 bug, when last item not showing
      // RXADMIN-4037: should not be nessesary anymore
      // list.push({ text: '', value: '' });
      this.items.push(list);
    });
  }

  private sanitizeOptions() {
    const columns = this._payload?.properties?.columns;

    if (!Array.isArray(columns) || !columns.length) {
      return;
    }

    columns.forEach((col) => {
      const items = Array.isArray(col?.items?.value) ? col.items.value : [];
      const seenValues = new Set<number>();

      let maxVal = items.reduce((max, item) => {
        const val = parseInt(item?.properties?.value?.value, 10);
        return isNaN(val) ? max : Math.max(max, val);
      }, 0);

      items.forEach((item) => {
        const val = parseInt(item?.properties?.value?.value, 10);

        if (isNaN(val)) {
          maxVal++;
          if (item?.properties?.value) {
            item.properties.value.value = maxVal;
          }
          seenValues.add(maxVal);
          return;
        }

        if (seenValues.has(val)) {
          maxVal++;
          if (item?.properties?.value) {
            item.properties.value.value = maxVal;
          }
          seenValues.add(maxVal);
        } else {
          seenValues.add(val);
        }
      });
    });
  }
}
